module.exports = __webpack_public_path__ + "img/spare-parts-tool-modal.9fe9fcf3.png";